import type {ActionMenuItem} from '@Components/action-menu/action-menu.types';
import {EventWizardCoverMenuOpener} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';
import {EventsCreateCoverGA4Source, EventsCreateCoverGA4Type} from '@Libraries/ga-events';

/** The tile is the cover's thumbnail itself, square and as tall as the Styles tile beside it. */
export const COVER_TILE_SIZE = 84;

export enum CoverTileMenuItemId {
  EDIT_DESIGN = 'edit-design',
  AI_DESIGNS = 'ai-designs',
  MY_DESIGNS = 'my-designs',
  UPLOADS = 'uploads',
  REMOVE = 'remove',
}

export interface CoverTileMenuItem extends Omit<ActionMenuItem, 'id'> {
  id: CoverTileMenuItemId;
}

export const COVER_MENU_OPENER_GA4_SOURCES: Record<EventWizardCoverMenuOpener, EventsCreateCoverGA4Source> = {
  [EventWizardCoverMenuOpener.TILE]: EventsCreateCoverGA4Source.OVERVIEW_COVER_TILE,
  [EventWizardCoverMenuOpener.PREVIEW]: EventsCreateCoverGA4Source.OVERVIEW_PREVIEW_COVER,
};

export const COVER_TILE_MENU_ITEM_GA4_TYPES: Record<CoverTileMenuItemId, EventsCreateCoverGA4Type> = {
  [CoverTileMenuItemId.EDIT_DESIGN]: EventsCreateCoverGA4Type.EDIT_DESIGN,
  [CoverTileMenuItemId.AI_DESIGNS]: EventsCreateCoverGA4Type.AI_DESIGNS,
  [CoverTileMenuItemId.MY_DESIGNS]: EventsCreateCoverGA4Type.MY_DESIGNS,
  [CoverTileMenuItemId.UPLOADS]: EventsCreateCoverGA4Type.UPLOAD,
  [CoverTileMenuItemId.REMOVE]: EventsCreateCoverGA4Type.REMOVE,
};
